<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1 || pageLoading2 || accessLoader" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<div class="card" *ngIf="user_type=='cdm'">
	<div class="card-header bg-primary">
		Send Mail
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="sendMail()" #modform="ngForm">
			<div class="row">
				<div class="col">
					<label class="me-5">
						Company:
						<strong>{{companyDetails?.name}}</strong>
					</label>
					<label class="me-5">BCC count:
						<strong>{{getBCC_Count()}}</strong>
					</label>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							CC
						</span>
						<tag-input formControlName="cc_emails" class="form-control" id="cc_emails"
							[placeholder]="mailIdPlaceholder" [secondaryPlaceholder]="mailIdPlaceholder"
							[separatorKeys]="[' ']" [editable]="false" [validators]="emailvalidators"
							[errorMessages]="emailerrormessages" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"
							[separatorKeyCodes]="[13]">
						</tag-input>
					</div>
					<p *ngIf="showError('cc_emails')" class="text-danger">
						<span *ngIf="f1.cc_emails.errors?.required">
							Required
						</span>
					</p>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							BCC
							<span class="text-danger">*</span>
						</span>
						<tag-input formControlName="bcc_emails" class="form-control" id="bcc_emails" #bcc_emails
							[placeholder]="mailIdPlaceholder" [secondaryPlaceholder]="mailIdPlaceholder"
							[separatorKeys]="[' ']" [editable]="false" [validators]="emailvalidators"
							[errorMessages]="emailerrormessages" [identifyBy]="'email'" [displayBy]="'name'"
							[addOnPaste]="true" [pasteSplitPattern]="splitPattern" [separatorKeyCodes]="[13]">
							<!-- <ng-template let-item="item" let-index="index">
								<span class="tag-text">{{ item.name }}: {{ item.email }}</span>
								<fa-icon [icon]="['fas','times']" class="ms-1"
									(click)="bcc_emails.removeItem(item, index)"></fa-icon>
							</ng-template> -->
						</tag-input>
					</div>
					<p *ngIf="showError('bcc_emails')" class="text-danger">
						<span *ngIf="f1.bcc_emails.errors?.required">
							Required
						</span>
					</p>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							Subject
							<span class="text-danger">*</span>
						</span>
						<input class="form-control" formControlName="subject" id="subject" />
					</div>
					<p *ngIf="showError('subject')" class="text-danger">
						<span *ngIf="f1.subject.errors?.required">
							Required
						</span>
					</p>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<!-- <textarea class="form-control" formControlName="mail_content" id="mail_content"></textarea> -->
					<div class="mb-editor text_editor_container">
						<quill-editor formControlName="mail_content" id="mail_content" [modules]="quillConfig"
							[placeholder]="'Type your mail here...'"></quill-editor>
					</div>
					<p *ngIf="showError('mail_content')" class="text-danger">
						<span *ngIf="f1.mail_content.errors?.required">
							Required
						</span>
					</p>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<app-file-uploader #fileUploaderComponent></app-file-uploader>
				</div>
			</div>
			<!-- <div class="row mt-3">
				<div class="col-lg-1 col-md-1 col-sm-1">
					<label class="mt-1">
						Attachments:
					</label>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<ngx-file-drop dropZoneLabel="Drop file here" browseBtnLabel="Browse file" [multiple]="true"
						(onFileDrop)="uploadFile($event)">
						<ng-template multiple="false" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
							<div style="text-align: center;">
								<button type="button" class="btn btn-outline-primary btn-sm"
									(click)="openFileSelector()">
									Drop Or Browse file
								</button>
							</div>
						</ng-template>
					</ngx-file-drop>
				</div>
				<div class="col-lg-7 col-md-7 col-sm-7">
					<table class="table table-bordered">
						<tbody>
							<tr>
								<th colspan="3">
									{{files.length}} File{{files.length>1?'s':''}} selected
								</th>
							</tr>
							<tr *ngFor="let att of files;let i = index;">
								<td>{{i+1}}</td>
								<td>{{att.name}}</td>
								<td>
									<fa-icon role="button" [icon]="['fas','times']" class="text-danger"
										(click)="removeFile(i)" matTooltip="Remove"></fa-icon>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div> -->
			<div class="row mt-3">
				<div class="col">
					<button type="submit" [disabled]="showMailLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showMailLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showMailLoader" [icon]="['fas', 'paper-plane']"></fa-icon>
						</span>
						<span>Send</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/company']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="user_type!='cdm'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>